import http from "../../services/http-client";
import {
  CASSETTES_TYPE,
  contractStatus,
  CUSTOMER_STATUS,
  CUSTOMER_TYPES,
} from "./constants";

export const ModifyCustomerDetails = (customerDetails, currencies) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const customerTypeObjIndex = CUSTOMER_TYPES.findIndex(
    (elm) => elm.id === customerDetails.customerType
  );
  const customerStatusObjIndex = CUSTOMER_STATUS.findIndex(
    (elm) => elm.id === customerDetails.status
  );
  const customerInformation = {
    clientId: customerDetails.clientId,
    name: customerDetails.name,
    shortName: customerDetails.shortName,
    customerType:
      customerTypeObjIndex !== -1 ? CUSTOMER_TYPES[customerTypeObjIndex] : null,
    customerCode: customerDetails.customerCode,
    status:
      customerStatusObjIndex !== -1
        ? CUSTOMER_STATUS[customerStatusObjIndex]
        : null,
    hasSeparateDispenseCount: customerDetails.hasSeparateDispenseCount,
    requiresEVhr: customerDetails.requiresEVhr,
    offeredServices: customerDetails.offeredServices.map((service) => ({
      serviceName: { id: service.serviceName, text: service.serviceName },
      expanded: false,
      cassettes: service.cassettes.map((cassette) => ({
        description: { id: cassette.description, text: cassette.description },
        denomination: cassette.denomination,
        currency: currencies.filter(
          (cur) => cur.shortName === cassette.denomination.split(" ")[0]
        )[0],
        multiple: {
          id: Number(cassette.denomination.split(" ")[1]),
          text: Number(cassette.denomination.split(" ")[1]),
        },
        cassetteType: CASSETTES_TYPE.filter(
          (type) => type.id === cassette.cassetteType
        )[0],
        maker: cassette.maker,
        limit: cassette.limit,
        dualScanning: cassette.dualScanning,
      })),
      denominations: service.denominations.map((deno) => ({
        denominationCurrency: currencies.filter(
          (cur) => cur.shortName === deno.currency
        )[0],
        denominationMultiple: {
          id: Number(deno.multiple),
          text: Number(deno.multiple),
        },
        shape: {
          id: deno.shape,
          text: deno.shape,
        },
        version: deno.version,
      })),
    })),
    accounts: customerDetails.accounts,
    contactPersons: customerDetails.contactPersons,
    insuranceLimits: customerDetails.insuranceLimits.map((limit) => ({
      type: { id: limit.type, text: limit.type },
      currency: currencies.filter(
        (curr) => curr.shortName === limit.currency
      )[0],
      pavement: limit.pavement,
      van: limit.van,
      bag: limit.bag,
    })),
    replenishmentModels: customerDetails.replenishmentModels.map((model) => ({
      code: model.code,
      expanded: false,
      denominations: model.denominations.map((deno) => ({
        currency: currencies.filter(
          (cur) => cur.shortName === deno.denomination.split(" ")[0]
        )[0],
        multiple: {
          id: Number(deno.denomination.split(" ")[1]),
          text: Number(deno.denomination.split(" ")[1]),
        },
        noOfCassettes: deno.noOfCassettes,
        noOfNotes: deno.noOfNotes,
      })),
    })),
    contracts: customerDetails.contracts.map((contract) => ({
      contractCode: contract.contractCode,
      autoRenew: contract.autoRenew,
      autoRenewFor: contract.autoRenewFor,
      startDate: contract.startDate ? new Date(contract.startDate) : null,
      endDate: contract.endDate ? new Date(contract.endDate) : null,
      status: contractStatus.filter((elm) => elm.id === contract.status)[0],
      expanded: false,
      contractSLAs: contract.contractSLAs.map((sla) => ({
        region: {
          id: sla.region,
          text: sla.region,
        },
        serviceType: {
          id: sla.serviceType,
          text: sla.serviceType,
        },
        activityType: {
          id: sla.activityType,
          text: sla.activityType,
        },
        responseTime: sla.responseTime,
        attendedTime: sla.attendedTime,
        resolutionTime: sla.resolutionTime,
      })),
      invoicingCatalogs: contract.invoicingCatalogs.map((catalog) => ({
        invoicingCode: catalog.invoicingCode,
        currency: currencies.filter(
          (curr) => curr.shortName === catalog.currency
        )[0],
        rate: catalog.rate,
        discount: catalog.discount,
      })),
    })),
    escalationGroups: customerDetails.escalationGroups.map((group) => {
      const item = {
        region: { id: group.region, text: group.region },
        routeNo: "",
        escalationLevel: group.escalationLevel,
        inAppRecipients: group.inAppRecipients.map((elm) => ({ item: elm })),
        emailRecipients: group.emailRecipients.map((elm) => ({ item: elm })),
        callRecipients: group.callRecipients.map((elm) => ({ item: elm })),
      };
      http
        .get(`${API_URL}/lookups/routes/region/${group.region}`)
        .then((res) => {
          item.routeNo = res.data.filter(
            (elm) => elm.routeNo === group.routeNo
          )[0];
        });
      return item;
    }),
  };
  const modifiedCustomer = { ...customerDetails, ...customerInformation };
  // console.log("modifiedCustomer", modifiedCustomer);
  return modifiedCustomer;
};
